import React, { useEffect, useState, useContext } from "react";
import "./StatusQuo.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { LanguageContext } from "../../context/LanguageContext";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const StatusQuo = () => {
  const { currentLang } = useContext(LanguageContext);
  const [statusQuo, setStatusQuo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatusQuo = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${API_BASE}/api/statusquosection?lang=${currentLang}`
        );
        setStatusQuo(res.data);
      } catch (err) {
        console.error("Error fetching Status Quo data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStatusQuo();
  }, [currentLang]);

  if (loading) {
    return <div className="statusquo-loading">Loading...</div>;
  }

  if (!statusQuo) {
    return <div className="statusquo-error">No Status Quo data found.</div>;
  }

  return (
    <div className="statsQuo">
      {/* ===== Text ===== */}
      <div className="statsquo-text">
        <div className="statsQuo-head">
          <h1>{statusQuo.title}</h1>
        </div>
        <div className="statsQuo-parag">
          <p>{statusQuo.description}</p>
        </div>
      </div>

      {/* ===== Slider ===== */}
      <div className="statsQuo-slider">
        {statusQuo.images && statusQuo.images.length > 0 ? (
          <Swiper
            modules={[Pagination, Autoplay, EffectFade]}
            pagination={{ clickable: true }}
            effect="fade"
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            loop={true}
            className="status-swiper"
          >
            {statusQuo.images.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                className="stqiC"
                  src={
                    img.startsWith("http")
                      ? img
                      : `${API_BASE}${img}`
                  }
                  alt={`MHERO Slide ${index + 1}`}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <p className="no-images">No images available.</p>
        )}
      </div>
    </div>
  );
};

export default StatusQuo;
